@if (!noResults) {
    <div class="table-container">
        @if (factory) {
            <div class="data-table">
                <div class="table-wrapper" cdkDropListGroup>
                    <table
                        mat-table
                        [dataSource]="dataSource"
                        matSort
                        [matSortActive]="factory.sortActive"
                        matSortDisableClear
                        [matSortDirection]="factory.sortDirection"
                        (matSortChange)="handleSortBy($event)"
                        cdkDropListGroup
                    >
                        @for (column of displayedColumns; track column; let colIndex = $index) {
                            <ng-container
                                matColumnDef="{{ column }}"
                                [sticky]="factory.columns[colIndex]?.fixed"
                                class="table-col"
                            >
                                <th mat-header-cell *matHeaderCellDef>
                                    <span
                                        [matTooltip]="factory.columns[colIndex]?.header"
                                        [disabled]="factory.columns[colIndex]?.sortKey === ''"
                                        mat-sort-header
                                        class="col-header"
                                    >
                                        {{ this.truncateText(factory.columns[colIndex]?.header) }}
                                    </span>
                                </th>
                                <td mat-cell *matCellDef="let item">
                                    @if (factory.columns[colIndex]?.formatter === 'html') {
                                        <span [innerHTML]="item[column]" class="html-table-content"></span>
                                    }
                                    @if (factory.columns[colIndex]?.formatter === 'text') {
                                        {{ item[column] }}
                                    }
                                    @if (
                                        actions.length > 0 &&
                                        factory.columns[colIndex]?.formatter === 'actions' &&
                                        !disableAction(item)
                                    ) {
                                        @for (action of actions; track action) {
                                            <button
                                                mat-icon-button
                                                [attr.aria-label]="action.label"
                                                (click)="onClickAction(item, action.id, $event)"
                                            >
                                                <mat-icon [color]="action.color">{{ action.icon }}</mat-icon>
                                            </button>
                                        }
                                    }
                                </td>
                            </ng-container>
                        }
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns; let rowIndex = index"
                            (click)="onClickRow(row, $event)"
                        ></tr>
                    </table>
                </div>
                <!-- pagination -->
                <mat-paginator
                    [length]="paginationConfig.totalRecords"
                    [pageIndex]="paginationConfig.currentPage"
                    [pageSize]="paginationConfig.pageSize"
                    [pageSizeOptions]="paginationConfig.pageSizeOptions"
                    [showFirstLastButtons]="true"
                    (page)="handlePage($event)"
                ></mat-paginator>
            </div>
        }
        <!-- loading spinner -->
        @if (loading) {
            <div id="app_table_loading" class="app-table-spinner-container">
                <mat-spinner diameter="40" class="table-spinner"></mat-spinner>
            </div>
        }
    </div>
}

<!-- no results -->
@if (noResults && !loading) {
    <div id="app_table_no_results" class="no-results">No results were found for your query.</div>
}
